import { NotificationResponseDto } from "../shared/dtos/notification/NotificationResponseDto";
import { NotificationSummaryDto } from "../shared/dtos/notification/NotificationSummaryDto";

export class NotificationMapper {
  public static mapNotificationToSummary(
    notification: NotificationResponseDto,
  ): NotificationSummaryDto {
    return {
      id: notification.id,
      targetUserId: notification.targetUserId,
      targetUserName: notification.targetUserName,
      type: notification.type,
      subject: notification.subject,
      messageBody: notification.messageBody,
      channel: notification.channel,
      status: notification.status,
      isRead: notification.isRead,
      readAt: notification.readAt,
      relatedEntityId: notification.relatedEntityId,
      relatedContext: notification.relatedContext,
      createdAt: notification.createdAt,
    };
  }
}
